import BaseRepository from '@/repositories/base/BaseRepository';

class InvoiceRepository extends BaseRepository {
  // 获取可开票发票列表
  getInvoiceAblesWithCPC(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/getInvoiceAblesWithCPC',
      data: params,
    });
  }

  //获取发票历史信息列表 带CPC
  getInvoiceHistoryWithCPC(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/getInvoiceHistoryWithCPC',
      data: params,
    });
  }

  //获取发票详情 带CPC
  getInvoiceDetailWithCPC(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/getInvoiceDetailWithCPC',
      data: params,
    });
  }
  
  //增加缓冲字符串
  addCacheInvoiceJson(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/addCacheInvoiceJson',
      data: params,
    });
  }

  //获取缓冲字符串
  getCacheInvoiceJson(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/getCacheInvoiceJson',
      data: params,
    });
  }
  //钱包概览
  getWalletInfo(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/wallet/getWalletInfo',
      data: params,
    });
  }
 
  //账户余额抹零
  accountTruncation(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/account-truncation',
      data: params,
    });
  }
  //资质校验
  checkCertify(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/checkCertify',
      data: params,
    });
  }


  //发票邮寄状态及单号
  invoicePostMessage(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/invoicePostMessage',
      data: params,
    });
  }

  //提交发票申请
  applyInvoice(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/invoice/applyInvoice',
      data: params,
    });
  }
  
  
  

}

export default InvoiceRepository;
